import { FC } from 'react';
import { useRouter } from 'next/router';
import { Tabbar, defaultColors, Box } from '@lifechurch/react-ion';
import { useTranslation } from 'next-i18next';

interface AnalyticsTabsProps {
  activeId: string;
}

const AnalyticsTabs: FC<AnalyticsTabsProps> = ({ activeId }) => {
  const router = useRouter();
  const { t } = useTranslation('common');

  const onTabClick = async (id: string): Promise<void> => {
    await router.push(`/analytics/${id}`);
  };

  return (
    <Box marginBlockEnd={7}>
      <Tabbar
        activeColor={defaultColors.brands.chop}
        activeId={activeId}
        elements={[
          { text: t('overview'), id: 'overview' },
          { text: t('services'), id: `services` },
          { text: t('reporting'), id: 'reporting' },
        ]}
        onClick={onTabClick}
      />
    </Box>
  );
};

export default AnalyticsTabs;
